<template>
    <div id="contact_container" class="container contact-container">
        <ContactFormMobile v-if="isMobileAtLoading" :branche="contactBranche"></ContactFormMobile>
        <ContactForm v-else :branche="contactBranche"></ContactForm>
        <BranchesMap @brancheChanged="setContactBranche($event)"></BranchesMap>
        <!--<BranchesMap></BranchesMap>-->
    </div>
</template>

<script>
import width from "../../../helpers/width";
import ContactForm from "./ContactForm";
import ContactFormMobile from "./ContactFormMobile";
import BranchesMap from "../BranchesMap";
export default {
    mixins:[width],
    components:{
        ContactForm,ContactFormMobile,BranchesMap
    },
    data(){
        return{
            contactBranche:null,
        }
    },
    methods:{
        setContactBranche(payload){
            this.contactBranche = payload;
        }
    }
}
</script>

<style scoped>

</style>